import { Close as CloseIcon } from '@mui/icons-material'
import { Box, styled } from '@mui/material'
import { FC } from 'react'

const CrossBox = styled(Box)`
  align-items: center;
  aspect-ratio: 1;
  background-color: #bb410e;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  width: 20px;
`

const StyledCloseIcon = styled(CloseIcon)`
  color: white;
  font-size: 14px;
`

const ApeironRedCrossIcon: FC<Props> = props => {
  const { className } = props

  return (
    <CrossBox className={className}>
      <StyledCloseIcon className='Custom-Close-Icon' />
    </CrossBox>
  )
}

type Props = {
  className?: string
}

export default ApeironRedCrossIcon
